import { useQuery } from 'react-query'
import { api } from '../../../api'
import { localConfig } from '../../../../Configs/localConfig'
import { errorAlert } from '../../../../utils/alert'

type Finalidades = {
  cod: number
  cod_inoculante: number
  cod_finalidade: number
  inoculante_nome: string
  finalidade_nome: string
}

type AplicacaoBio = {
  cod_bioinsumo: number
  cod_aplicacao: number
  cod_replica: null
  bioinsumo_nome: string
  aplicacao_nome: string
}

type Microrganismo = {
  cod: number
  nome_cientifico: string
  tipo_microrganismo: number
  tipo_microrganismo_nome: string
}

type BioComposicao = {
  tipo_porcentagem_nome: string
  cod: number
  cod_produto: number
  cod_microrganismo: number
  concentracao: string
  cepa: null
  produto_nome: string
  microrganismo_nome: string
  densidade: string
  porcentagem: string
  tipo_porcentagem: string
  microrganismo: Microrganismo[]
}

type ParametrosBio = {
  origem: number
  formulacao: number
  tecnologia: number
  volume_dose: string
  doses_por_hectare: string
  forma_dosar: string
  unidade_hectare: string
  cod_bioinsumo: number
  formulacao_nome: string
  tecnologia_nome: string
  origem_nome: string
}

type Item = {
  cod: number
  cod_conta: number
  cod_cliente: null
  cod_categoria_produto: number
  cod_fabricante: number
  nome: string
  descricao: string
  cod_formulacao: null
  adjuvante: number
  cod_tipo_adjuvante: null
  observacao: null
  cod_medida_aplicacao: null
  cod_classe_agronomica: null
  cod_replica: null
  cod_variedade_hibrido: null
  cod_fertilizante: null
  cod_tecnologia: null
  acao_ph_calda: null
  cod_fornecedor: null
  fabricante_nome: string
  categoria_produto_nome: string
  classe_agronomica_nome: null
  nome_medida_aplicacao: null
  finalidades: Finalidades[]
  parametros_bioinsumo: ParametrosBio[]
  aplicacoes_bioinsumo: AplicacaoBio[]
  biocomposicao: BioComposicao[]
}

interface PropsBioInsumos {
  itens: Item[]
  total: number
}

export const useGetBioInsumos = (pagination = 15, page = 1, nome?: string, codCategoriaProduto?: number) => {
  const queryKey: any = [`recomendacao/bioinsumo`]

  const { data, isFetching, refetch, isFetchedAfterMount, isError } = useQuery<
    PropsBioInsumos,
    Error
  >(
    queryKey,
    async () => {
      const paramNome = nome ? `&nomeGeral=${nome}` : ''
      return api
        .get(
          `recomendacao/bioinsumo?codConta=${localConfig()?.conta}&codCliente=${localConfig()?.codCliente
          }&codCategoriaProduto=${codCategoriaProduto}&pagination=${pagination}&page=${page}${paramNome}&embed=bioinsumo`
        )
        .then((response): any => {
          return response.data
        })
        .catch((error) => {
          errorAlert(error?.response?.data?.error ?? 'Falha ao obter lista de bioInsumos!')
        })
    },
    {
      enabled: false,
      refetchOnWindowFocus: false,
    }
  )

  return {
    data_bioInsumo: data,
    carregando_bioInsumo: isFetching,
    refetch_data_bioInsumo: refetch,
    isFetched: isFetchedAfterMount,
    isError: isError,
  }
}